export default __webpack_public_path__ + "static/strategic-consulting-9ac4b666b3b8a8d533be25e0c51a8e2e.svg";